import React from "react"
import styles from "./styles.module.css"
import { Box, Flex, Text } from "@chakra-ui/react"
import LocationIcon from "@/shared/assets/icons/location"

interface IProps {
  results: any[]
  onSelect: (e: any, type: string) => void
}

export default function AddressDropdown({ results = [], onSelect }: IProps) {
  return (
    <Box
      p={2}
      position="absolute"
      top="calc(100% + 4px)"
      left={0}
      w="full"
      zIndex={1503} // over zone info
      maxH={363}
      bg="background.card"
      borderRadius="lg"
      overflowY="auto"
      boxShadow="0px 4px 6px 0px #00000033, 0px 4px 6px 0px #0000000A"
      border="1px solid rgba(255, 255, 255, 0.07)"
    >
      {results?.map(
        (item) =>
          item?.label && (
            <Option
              data={item}
              onSelect={() => onSelect(item, "suggest")}
              key={item?.distance + item?.description + item?.label + "suggest"}
            />
          )
      )}
    </Box>
  )
}

interface IOptionProps {
  data: { label: string; description: string; distance: string }
  onSelect: (data: any) => void
}

const Option = ({ data, onSelect }: IOptionProps) => {
  return (
    <Flex
      align="center"
      _hover={{
        bg: "background",
      }}
      className={styles.search_address_option}
      onClick={() => onSelect(data)}
    >
      <Box>
        <LocationIcon />
      </Box>
      <Box py={3}>
        <Text mb={0.5} fontWeight={500} color="text">
          {data?.label}
        </Text>
        <Text fontSize="small" color="text.muted" lineHeight={1.2}>
          {data?.description}
        </Text>
      </Box>
    </Flex>
  )
}
